<ng-container *ngrxLet="activeUser$ as activeUser">
  <div class="review-incorporation-request-wrapper text-sub !mx-4">
    <ul class="text-sub px-2">
      <li class="list-disc">
        <span class="mr-3">Request change company status to&colon;</span>
        <span class="mat-body-2 !text-sub capitalize">{{ jobDetail.changeCompanyStatusInput.status.toLowerCase() }}</span>
      </li>
      <li class="list-disc">
        <span class="mr-3">The company not doing business since:</span>
        <span class="mat-body-2 !text-sub">{{ jobDetail.changeCompanyStatusInput.stopCarryOnBusinessDate | date }}</span>
      </li>
    </ul>
  </div>
</ng-container>
